export const STORAGE_KEY = 'pb-a11y-settings';

export const CSS_PREFIX = 'pb-a11y-';

export const CLASSES = {
  active: CSS_PREFIX + 'active',
  panelOpen: CSS_PREFIX + 'panel-open',
  fontSize: CSS_PREFIX + 'font-size',
  lineHeight: CSS_PREFIX + 'line-height',
  letterSpacing: CSS_PREFIX + 'letter-spacing',
  wordSpacing: CSS_PREFIX + 'word-spacing',
  boldText: CSS_PREFIX + 'bold-text',
  dyslexia: CSS_PREFIX + 'dyslexia',
  darkContrast: CSS_PREFIX + 'dark-contrast',
  lightContrast: CSS_PREFIX + 'light-contrast',
  highContrast: CSS_PREFIX + 'high-contrast',
  invert: CSS_PREFIX + 'invert',
  monochrome: CSS_PREFIX + 'monochrome',
  highSaturation: CSS_PREFIX + 'high-saturation',
  lowSaturation: CSS_PREFIX + 'low-saturation',
  largeCursor: CSS_PREFIX + 'large-cursor',
  extraLargeCursor: CSS_PREFIX + 'xl-cursor',
  hideAnimations: CSS_PREFIX + 'hide-animations',
  reduceTransitions: CSS_PREFIX + 'reduce-transitions',
  highlightLinks: CSS_PREFIX + 'highlight-links',
  highlightHeadings: CSS_PREFIX + 'highlight-headings',
  readingGuide: CSS_PREFIX + 'reading-guide',
  readingMask: CSS_PREFIX + 'reading-mask',
  focusMode: CSS_PREFIX + 'focus-mode',
  hideImages: CSS_PREFIX + 'hide-images',
  keyboardNav: CSS_PREFIX + 'keyboard-nav',
  underlineLinks: CSS_PREFIX + 'underline-links',
  protanopia: CSS_PREFIX + 'protanopia',
  deuteranopia: CSS_PREFIX + 'deuteranopia',
  tritanopia: CSS_PREFIX + 'tritanopia',
};

export const CSS_VARS = {
  fontSize: '--' + CSS_PREFIX + 'font-size',
  lineHeight: '--' + CSS_PREFIX + 'line-height',
  letterSpacing: '--' + CSS_PREFIX + 'letter-spacing',
  wordSpacing: '--' + CSS_PREFIX + 'word-spacing',
};
